export default __webpack_public_path__ + "static/media/boy_bubble.6f64f3d0.jpg";